export { State, initialState } from './glossari.state';
export * from './glossari.actions';
export { glossariReducer } from './glossari.reducer';
export { GlossariEffects } from './glossari.effects';